export default __webpack_public_path__ + "static/media/icon-not-fire.da7bba3c.svg";